import React from 'react';
import styled from 'styled-components';
import {
  cssColorValue,
  screenMdMin,
  screenXlMin,
  screenXsMin,
  semanticColors,
  spacer16,
  spacer20,
  spacer4,
  spacer40,
  spacer48,
} from '@spotify-internal/encore-web';

import { MastheadHeaderData } from 'lib/sanity/types';
import { NavBarLogo } from 'components/Masthead/Header/Logo';
import { NavBarPrimaryLinks } from 'components/Masthead/Header/PrimaryLinks';
import { NavBarSecondaryLinks } from 'components/Masthead/Header/SecondaryLinks';
import { NavBarSideMenuWrapper } from 'components/Masthead/Header/SideMenu';

const NavBarWrapper = styled.header`
  align-items: center;
  box-sizing: border-box;
  background: ${cssColorValue(semanticColors.backgroundBase)};
  color: ${cssColorValue(semanticColors.textBase)};
  display: flex;
  justify-content: space-between;
  padding-block: ${spacer20};
  padding-inline: ${spacer40};
  position: relative;
  width: 100%;
  z-index: 1000;

  @media (max-width: ${screenMdMin}) {
    padding-block: ${spacer4};
    transition: transform 400ms ease-in-out;
    -webkit-transition: -webkit-transform 400ms ease-in-out;
  }

  @media (max-width: ${screenXsMin}) {
    padding-inline: ${spacer16};
  }

  @media (min-width: 1440px) {
    padding-inline: ${spacer48};
  }

  @media (min-width: ${screenXlMin}) {
    padding-inline: ${spacer48};
  }
`;

interface Props {
  data: MastheadHeaderData;
}

export const TurnkeyNavBar = ({ data }: Props) => {
  const { brand, primaryLinks, secondaryLinks, profileLinks } = data;

  return (
    <NavBarWrapper className="encore-inverted-dark-set encore-layout-themes" role="banner" data-testid="turnkey-header">
      <NavBarLogo brand={brand} />
      <NavBarPrimaryLinks primaryLinks={primaryLinks} />
      <NavBarSecondaryLinks secondaryLinks={secondaryLinks} profileLinks={profileLinks} />
      <NavBarSideMenuWrapper headerEntry={data} />
    </NavBarWrapper>
  );
};
